var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6874_46964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9401 48.3759C22.1063 48.3759 26.2944 44.1879 26.2944 39.0217C26.2944 33.8555 22.1063 29.6675 16.9401 29.6675C11.774 29.6675 7.58594 33.8555 7.58594 39.0217C7.58594 44.1879 11.774 48.3759 16.9401 48.3759Z",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7164 50.8448C22.3129 54.4847 20.226 59.3708 20.226 64.736V73.3465L19.4432 74.1293H2.84834C1.55205 74.1293 0.5 73.0773 0.5 71.781V64.736C0.5 55.6714 7.87378 48.2976 16.9384 48.2976C20.1634 48.2976 23.1755 49.2322 25.7164 50.8448Z",
    fill: "#55696E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5776 43.6008C47.0624 43.6008 52.3193 38.3439 52.3193 31.8591C52.3193 25.3744 47.0624 20.1174 40.5776 20.1174C34.0929 20.1174 28.8359 25.3744 28.8359 31.8591C28.8359 38.3439 34.0929 43.6008 40.5776 43.6008Z",
    fill: "#D78878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3198 31.8591C52.3198 38.3327 47.0517 43.6008 40.5781 43.6008V20.1174C47.0517 20.1174 52.3198 25.3855 52.3198 31.8591Z",
    fill: "#D78878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0612 48.3759C69.2274 48.3759 73.4154 44.1879 73.4154 39.0217C73.4154 33.8555 69.2274 29.6675 64.0612 29.6675C58.8951 29.6675 54.707 33.8555 54.707 39.0217C54.707 44.1879 58.8951 48.3759 64.0612 48.3759Z",
    fill: "#FFCCBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5006 64.736V71.781C80.5006 73.0773 79.4486 74.1293 78.1523 74.1293H61.7139L60.9311 73.3465V64.736C60.9311 59.3411 58.8208 54.4299 55.3828 50.7837C57.9034 49.2072 60.8779 48.2976 64.0623 48.2976C73.1268 48.2976 80.5006 55.6714 80.5006 64.736Z",
    fill: "#495959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4531 43.6012C28.7906 43.6682 19.4414 53.3058 19.4414 64.9684V74.1292C19.4414 75.4262 20.4928 76.4776 21.7897 76.4776H59.3631C60.66 76.4776 61.7115 75.4262 61.7115 74.1292V64.7359C61.7115 53.0409 52.1634 43.534 40.4531 43.6012Z",
    fill: "#F47160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7132 64.7359V74.1292C61.7132 75.4261 60.6617 76.4775 59.3648 76.4775H40.5781V43.6008C52.2321 43.6008 61.7132 53.0818 61.7132 64.7359Z",
    fill: "#F47160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3609 4.21053C48.4439 3.29343 46.957 3.29343 46.0399 4.21053L38.3071 11.9433L35.1143 8.75065C34.1974 7.83355 32.7104 7.83355 31.7933 8.75065C30.8762 9.66775 30.8762 11.1546 31.7933 12.0717L36.6465 16.9249C37.5635 17.842 39.0504 17.8422 39.9675 16.9249L49.3609 7.53155C50.278 6.61445 50.278 5.12764 49.3609 4.21053Z",
    fill: "#0ABF9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3625 7.53195L40.5781 16.3163V9.67363L46.0404 4.20984C46.9578 3.29399 48.4451 3.29399 49.3625 4.20984C50.2783 5.12725 50.2783 6.61453 49.3625 7.53195Z",
    fill: "#0ABF9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6874_46964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/selection.3d8f2d7e0d71f17953e49f227d811108.svg";
export { ForwardRef as ReactComponent };